import { useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.scss";
import LandingPage from "./landing/LandingPage";
import AllScans from "./components/AllScans";
import MyUploads from "./components/MyUploads";
import ResetPassword from "./components/ResetPassword";
import OAuthConsent from "./components/OAuthConsent";
import AuthHeader from "./components/AuthHeader";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./lib/queryClient";
import AnalysisPage from "./analysis/AnalysisPage";
import UrlAnalysisPage from "./analysis/UrlAnalysisPage";
import { initGA, logPageView } from "./analytics";
import { AuthProvider } from "./context/AuthContext";
import { SignInModalProvider } from "./context/SignInModalContext";
import { useInvalidateOnAuthChange } from "./lib/useInvalidateOnAuthChange";
import { GlobalSignInModal } from "./components/GlobalSignInModal";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname, location.search);
  }, [location]);

  return null;
};

const AppContent = () => {
  const location = useLocation();

  // Initialize GA once when the app mounts
  useEffect(() => {
    initGA();
  }, []);

  useInvalidateOnAuthChange();

  return (
    <>
      {/* link for the icon assets */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
      ></link>
      {/* Show fixed auth header on front page, all scans, and my uploads - hide on analysis pages and reset password */}
      {!location.pathname.includes("/analysis") &&
        !location.pathname.includes("/reset-password") &&
        !location.pathname.includes("/oauth/consent") && (
          <AuthHeader layout="fixed" />
        )}
      {/* All the routes */}
      <AnalyticsTracker />
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/analysis/:analysis_id" element={<AnalysisPage />} />
        <Route path="/analysis" element={<LandingPage />} />
        <Route path="/url-analysis" element={<UrlAnalysisPage />} />
        <Route path="/allscans" element={<AllScans />} />
        <Route path="/myuploads" element={<MyUploads />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/oauth/consent" element={<OAuthConsent />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <SignInModalProvider>
            <AppContent />
            <GlobalSignInModal />
          </SignInModalProvider>
          {process.env.REACT_APP_DEVTOOLS === "true" && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
        </QueryClientProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
